<div (blur)="onBlur.emit()" class="emd-select eu-basis_12 eu-basis_12_md">
    <input
        [disabled]="disabledSelect"
        class="emd-input"
        [(ngModel)]="selectedContent"
        [matAutocomplete]="selectLiveSearch"
        (keyup)="runLiveSearchOnList()"
        placeholder="{{ inputPlaceholder }}"
        [ngClass]="{ _state_error: hasError }"
        [attr.data-cy]="controlName"
    />

    <mat-autocomplete [attr.data-cy] #selectLiveSearch="matAutocomplete">
        <mat-option
            [attr.data-cy]="content.contentToShowOnSelectOption"
            *ngFor="let content of listToFilter"
            (click)="setSelectedContent(content)"
        >
            {{ content.contentToShowOnSelectOption }}
        </mat-option>
    </mat-autocomplete>
    <div class="emd-select__arrow"></div>
</div>
